(() => {
  if (customElements.get('vault-footer-accordion')) return;
  customElements.define('vault-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      this.mobile = matchMedia('(max-width: 767px)');
      this.onBreakpoint = () => this.querySelectorAll('.vault-footer__toggle').forEach((button) => this.updatePanel(button));
      this.mobile.addEventListener('change', this.onBreakpoint);
      this.onClick = (event) => {
        const button = event.target.closest('.vault-footer__toggle');
        if (!button || !this.contains(button) || !this.mobile.matches) return;
        button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
        this.updatePanel(button);
      };
      this.querySelectorAll('.vault-footer__toggle').forEach((button) => this.updatePanel(button));
      this.addEventListener('click', this.onClick);
      this.classList.add('is-enhanced');
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mobile.removeEventListener('change', this.onBreakpoint);
    }

    updatePanel(button) {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel || !this.contains(panel)) return;
      const collapsed = button.getAttribute('aria-expanded') !== 'true';
      panel.classList.toggle('is-collapsed', collapsed);
      panel.inert = this.mobile.matches && collapsed;
    }
  });
})();
